import {
  CommonListActions,
  DynamicTabsActions,
  GET_TAB,
  TabStatusCountActions,
  TabsActionButtonsActions,
} from "./AccessManagementAction";

const initialState = {
  fields: [],
  dynamicTabs: [],
  tabs: [],
  actionsButton: [],
  tab: "ACTIVE",
};

const AccessMangementReducer = (state = initialState, action) => {
  switch (action.type) {
    case CommonListActions.COMMON_LIST_SUCCESS:
      return {
        ...state,
        fields: action.payload,
      };
    case DynamicTabsActions.DYNAMIC_TABS_SUCCESS:
      return { ...state, dynamicTabs: action.payload };
    case TabStatusCountActions.TAB_STATUS_COUNT_SUCCESS:
      return {
        tabs: action.payload,
      };
    case TabsActionButtonsActions.TABS_ACTION_BUTTONS_SUCCESS:
      return {
        ...state,
        actionsButton: action.payload?.data?.ACTION_BUTTON_DTO,
      };
    case TabsActionButtonsActions.TABS_ACTION_BUTTONS_ERROR:
      return {
        ...state,
        actionsButton: [],
      };
    case GET_TAB:
      return { ...state, tab: action.payload };

    default:
      return state;
  }
};

export default AccessMangementReducer;
